<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
            {{title}}
            </div>
        </div>
        <div class="m-panel-body">
            <div>
                <p style="margin-bottom: 0">
                    <span>{{ $t('近三日上报率') }}</span>
                    <span class="ds-digital-bold font-24" style="line-height: 20px">
                        <animated-integer :value="upPercent.threeUpPercent"></animated-integer>
                    </span>
                    <span class="unit">%</span>
                    <span style="margin-left: 15px">{{ $t('开阀') }}</span>
                    <span class="ds-digital-bold font-24" style="line-height: 20px">
                        <animated-integer :value="fkStatusTotal.meterValveOpenCount"></animated-integer>
                    </span>
                    <span class="unit">{{ $t('个') }}</span>
                </p>
                <p style="margin-bottom: 0">
                    <span>{{ $t('近七日上报率') }}</span>
                    <span class="ds-digital-bold font-24" style="line-height: 20px">
                        <animated-integer :value="upPercent.sevenUpPercent"></animated-integer>
                    </span>
                    <span class="unit">%</span>
                    <span style="margin-left: 15px">{{ $t('关阀') }}</span>
                    <span class="ds-digital-bold font-24" style="line-height: 20px">
                        <animated-integer :value="fkStatusTotal.meterValveCloseCount"></animated-integer>
                    </span>
                    <span class="unit">{{ $t('个') }}</span>
                </p>
            </div>
            <div style="height: calc(100% - 45px);width: 100%">
                <Echart ref="option" :options="option" style="height: 100%"></Echart>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts/lib/echarts';
import animatedInteger from '@/components/maComponents/animated-integer';
import { putAction,getAction } from '@/api/manage'
export default {
    components: {
        animatedInteger
    },
    props: {
            titleImage: {
            type: String,
            default: ''
        },
    },
    data() {
        return{
            title: this.$t('物联网设备分析'),
            option: {},
            upPercent: {
                threeUpPercent: 100,
                sevenUpPercent: 100
            },
            fkStatusTotal: {
                meterValveOpenCount: 0,
                meterValveCloseCount: 0
            },
            url: {
                list: '/jeecg-charge/meter/waterAnalysis/meterReportingRate',
                meterFaultCount: '/jeecg-charge/meter/waterAnalysis/meterFaultCount'
            },
            meterFault: {
                meterFaultDetail: [
                {value: 0, name: this.$t('欠压')},
                {value: 0, name: this.$t('磁干扰')},
                {value: 0, name: this.$t('阀门故障')}],
                meterTotalCount: 0,
                meterFaultPercent: 0,
            },
            intervalId: null,
            angle: 0
        }
    },
    mounted() {
        
    },
    methods: {
        init() {
            this.$nextTick(() => {
                this.resetData()
                this.$refs.option.showLoading('default',{
                    maskColor: 'rgba(0,0,0,0.3)',
                    color: '#6ED9F2',
                    text: ''
                })
                this.queryDeviceAnasis()
                this.queryMeterFaultCount()
            })
        },
        resetData() {
            this.option = this.$options.data.call(this).option
            if(this.intervalId !== null){
                clearInterval(this.intervalId)
                this.intervalId = null;
            }
            this.angle = this.$options.data.call(this).angle
        },
        queryDeviceAnasis() {
            putAction(this.url.list, {}).then((res) => {
                if(res.success){
                    this.fkStatusTotal.meterValveOpenCount = res.result.meterValveOpenCount
                    this.fkStatusTotal.meterValveCloseCount = res.result.meterValveCloseCount
                    if(res.result.meterTotalCount>0) {
                        console.log(res.result.meterTotalCount)
                        this.upPercent.threeUpPercent = Number(((res.result.lastThreeDayMeterReportCount/res.result.meterTotalCount)*100).toFixed(0))
                        this.upPercent.sevenUpPercent = Number(((res.result.lastSevenDayMeterReportCount/res.result.meterTotalCount)*100).toFixed(0))
                    }
                }
            })
        },
        queryMeterFaultCount() {
            putAction(this.url.meterFaultCount, {}).then((res) => {
                if(res.success){
                    console.log(res);
                    this.meterFault.meterTotalCount = res.result.meterTotalCount
                    console.log(res.result.meterTotalCount);
                    this.meterFault.meterFaultDetail[0].value = res.result.meterBatteryFaultCount
                    this.meterFault.meterFaultDetail[1].value = res.result.meterMagicFaultCount
                    this.meterFault.meterFaultDetail[2].value = res.result.meterValveFaultCount
                    this.meterFault.meterFaultPercent = Number(((res.result.meterFaultCount/res.result.meterTotalCount)*100).toFixed(0))
                    this.setOption()
                    this.setIntervalId()
                }
            })
        },
        setIntervalId() {
            setTimeout(()=> {
                this.intervalId = setInterval(()=>{
                    this.angle = this.angle + 5
                    this.setOption()
                },100)
            },1000)
        },
        setOption() {
            let angle = this.angle
            let data = this.meterFault.meterFaultDetail
            let total = this.meterFault.meterTotalCount
            let meterFaultPercent = this.meterFault.meterFaultPercent
            let color = [{start: '#FAD961',end: '#F76B1C'},{start: '#00D2FF',end: '#3A7BD5'},{start: '#60E0B2',end: '#1DCC8C'}]
            let seriesData = []
            let innerSeriesData = []
            for(let i = 0;i < data.length;i++) {
                innerSeriesData.push({
                    value: 12,
                    name: '',
                    itemStyle: {
                        normal: {
                            borderWidth: 5
                        }
                    }
                }, {
                    value: 2,
                    name: '',
                    itemStyle: {
                        normal: {
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            },
                            color: 'rgba(0, 0, 0, 0)',
                            borderColor: 'rgba(0, 0, 0, 0)',
                            borderWidth: 0
                        }
                    }
                })
                seriesData.push({
                    name: data[i].name,
                    value: data[i].value,
                    itemStyle: {
                        normal: {
                            borderWidth: 5,
                            color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                [
                                    {offset: 0, color: color[i].start},
                                    {offset: 1, color: color[i].end}
                                ]
                            ),
                            borderColor:new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                [
                                    {offset: 0, color: color[i].start},
                                    {offset: 1, color: color[i].end}
                                ]
                            )
                        }
                    }
                })
            }
            this.$refs.option.hideLoading()
            let that = this
            this.option = {
                color: ['#F76B1C','#0067FF', '#1DCC8C'],
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(0,11,42,0.9)',
                    borderColor: '#5D6A94',
                    borderWidth: 1,
                    borderRadius: 8,
                    textStyle: {
                        color: '#CEE2FF',
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            color: '#019AF3'
                        }
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                title: {
                    text: `{total|${total}}{unit|${this.$t('个')}} {total|${meterFaultPercent}}{unit|%}`,
                    textStyle: {
                        color: '#52C4DF',
                        rich: {
                            total: {
                                color: '#52C4DF',
                                fontWeight: 500,
                                fontSize: 24,
                                fontFamily: 'ds-digital-bold'

                            },
                            unit: {
                                color: '#2A6BAC',
                                fontSize: 12,
                            }
                        }
                    },
                    left: 'center',
                    top: 'center',
                    itemGap: 0,
                    subtext: this.$t('总计/故障率'),
                    subtextStyle: {
                        color: '#fff',
                        verticalAlign: 'middle',
                        lineHeight: 12
                    }
                },
                series: [
                    {
                        name: "ring5",
                        type: 'custom',
                        coordinateSystem: "none",
                        renderItem: function(params, api) {
                            return {
                                type: 'arc',
                                shape: {
                                    cx: api.getWidth() / 2,
                                    cy: api.getHeight() / 2,
                                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                                    startAngle: (0 + angle) * Math.PI / 180,
                                    endAngle: (90 + angle) * Math.PI / 180
                                },
                                style: {
                                    stroke: "#00A2F3",
                                    opacity: 0.5,
                                    fill: "transparent",
                                    lineWidth: 2
                                },
                                silent: true
                            };
                        },
                        data: [0]
                    },
                    {
                        name: "ring5",
                        type: 'custom',
                        coordinateSystem: "none",
                        renderItem: function(params, api) {
                            return {
                                type: 'arc',
                                shape: {
                                    cx: api.getWidth() / 2,
                                    cy: api.getHeight() / 2,
                                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                                    startAngle: (120 + angle) * Math.PI / 180,
                                    endAngle: (210 + angle) * Math.PI / 180
                                },
                                style: {
                                    stroke: "#00A2F3",
                                    opacity: 0.5,
                                    fill: "transparent",
                                    lineWidth: 2
                                },
                                silent: true
                            };
                        },
                        data: [0]
                    },
                    {
                        name: "ring5",
                        type: 'custom',
                        coordinateSystem: "none",
                        renderItem: function(params, api) {
                            return {
                                type: 'arc',
                                shape: {
                                    cx: api.getWidth() / 2,
                                    cy: api.getHeight() / 2,
                                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                                    startAngle: (240 + angle) * Math.PI / 180,
                                    endAngle: (330 + angle) * Math.PI / 180
                                },
                                style: {
                                    stroke: "#00A2F3",
                                    fill: "transparent",
                                    opacity: 0.5,
                                    lineWidth: 2
                                },
                                silent: true
                            };
                        },
                        data: [0]
                    },
                    {
                        name: '',
                        type: 'pie',
                        radius: ['50%', '55%'],
                        center: ['50%', '50%'],
                        animationDelay: 100,
                        animationDuration: 2000,
                        label: {
                            show: true,
                            position: 'outer',
                            width:0,
                            height: 0,
                            lineHeight: 0,
                            padding: [2,-2,2,-2],
                            borderRadius: 2,
                            distanceToLabelLine: 0,
                            formatter: (params) => {
                                let percent = 100
                                if(total == 0) {
                                }else{
                                  percent  = ((params.value / total) * 100).toFixed(0);
                                }
                                let index = params.dataIndex
                                return [`{topnumber${index}|${params.value}}{top${index}|${this.$t('个')}}{topnumber${index}|${percent}}{top${index}|%}\n{bottom${index}|${params.name}}`,`{hr${index}|}`].join('\n')
                            },
                            align: 'center',
                            rich: that.setRichText(color),
                            /*
                            rich: {
                                top: {
                                    verticalAlign: 'bottom',
                                    // bottom：文字在上圆点在下
                                    // top: 文字在下圆点在上
                                    padding: [10, 10, 0, 10],
                                    //color: '#FFFFFF',
                                    // padding：[上， 右， 下，左]，
                                    // 上：圆点到上文字间距, 文字上移距离
                                    // 右：文字与右侧圆点间距, 文字左移距离
                                    // 下：圆点到下文字间距, 文字下移距离
                                    // 左：文字与左侧圆点间距, 文字右移距离
                                    align: 'center'
                                    // center:文字圆点居中，right文字在圆点左侧，left文字在圆点右侧
                                },
                                bottom: {
                                    padding: [0, 10, 10, 10],
                                    verticalAlign: 'top',
                                    align: 'center',
                                    color: '#FFFFFF',
                                }
                            }
                            */
                        },
                        labelLine: {
							normal: {
								smooth: 0.2,
								length: 15,
								length2: 45,
							}
						},
                        data: seriesData
                    }
                ]
            };
        },
        setRichText(colorList) {
            let richList = {}
            for(let i = 0;i< colorList.length;i++) {
                richList[`top${i}`] = {
                    color: colorList[i].start,
                    verticalAlign: 'bottom',
                    padding: [5, 0, 0, 0],
                    align: 'center'
                }
                richList[`topnumber${i}`] = {
                    color: colorList[i].start,
                    fontFamily: 'ds-digital-bold',
                    verticalAlign: 'bottom',
                    padding: [5, 0, 0, 0],
                    fontSize: 20,
                    align: 'center'
                }
                richList[`bottom${i}`] = {
                    color: colorList[i].start,
                    verticalAlign: 'top',
                    padding: [0, 0, 5, 0],
                    align: 'center'
                }
                richList[`hr${i}`] = {
                    backgroundColor: colorList[i].start,
                    borderRadius: 3,
                    width: 3,
                    height: 3,
                    align: 'center',
                    padding: [3, 3, 0, -12]
                }
            }
            return richList
        }
    },
    beforeDestroy() {
        this.angle = 0;
        if(this.intervalId != null){
            clearInterval(this.intervalId)
            this.intervalId = null;
        }
    }
}
</script>